import { createStyles, makeStyles } from '@mui/styles';
import { Theme } from '@mui/material/styles';

const useStickyStyles = makeStyles<Theme>((theme: Theme) =>
    createStyles({
        root: {
            position: 'sticky',
        },
    }),
);

export default useStickyStyles;
